import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const activityLabel = {
  padel: "Torneo di Padel",
  beach: "Torneo di Beach Volley",
  entrambi: "Padel + Beach Volley",
  nessuno: "Nessun torneo",
};

export function buildICS(settings, reg) {
  const dt = (settings.event_date_iso || "2026-09-17T09:00:00").replace(/[-:]/g, "").split(".")[0];
  const dtStart = dt.length === 15 ? dt : `${dt}00`;
  const uid = `${reg?.id || Date.now()}@reacompany`;
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Rea Company//Convention//IT",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTART:${dtStart}`,
    `SUMMARY:Convention Rea Company Srl x Fastweb + Vodafone`,
    `LOCATION:${settings.location}, ${settings.city}`,
    `DESCRIPTION:Attività: ${activityLabel[reg?.tournament] || "Convention"}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
}

export function downloadFile(filename, content, type = "text/plain") {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export { activityLabel };
